import { render, staticRenderFns } from "./ArticleAttributeForm.vue?vue&type=template&id=090c18a4&scoped=true&"
import script from "./ArticleAttributeForm.vue?vue&type=script&lang=js&"
export * from "./ArticleAttributeForm.vue?vue&type=script&lang=js&"
import style0 from "./ArticleAttributeForm.vue?vue&type=style&index=0&id=090c18a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c18a4",
  null
  
)

export default component.exports